import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import React from "react";
import { GlobalAlertContext } from "../../../../context/GlobalAlertContext";
import FaqC from "./FaqC";

function FaqCPage() {
  return (
    <GlobalAlertContext.Consumer>
      {(alertObj) => (
        <>
          <Grid>
            <Row>
              <FaqC />
            </Row>
          </Grid>
        </>
      )}
    </GlobalAlertContext.Consumer>
  );
}

export default FaqCPage;
